import { getResizedImgUrl } from "utils/imageUtil";
import React from "react";
import { useNavigate } from "react-router-dom";
import { CHANNEL_ROUTE } from "@/constant/urlConstant";

import { cls, isMo } from "@/utils/util";

const HorizontalCourseCard = ({
  thumbnail,
  lecturers,
  title,
  topic,
  topicCategory,
  highlightedText,
  imageWidth = "100%",
  channel,
  isShowClassNameBox = true,
}: {
  thumbnail: string;
  lecturers: string[];
  title: string;
  regularPrice?: number;
  salePrice?: number;
  topic?: string[];
  topicCategory?: string[];
  level?: string;
  isSwiper?: boolean;
  isFree?: boolean;
  isSoldOut?: boolean;
  highlightedText?: (title: string) => string | React.ReactNode;
  imageWidth?: string;
  channel?: {
    channelId: string;
    title: string;
  };
  isShowClassNameBox?: boolean;
}) => {
  const navigate = useNavigate();
  const isMobile = isMo();

  return (
    <section className="cursor-pointer rounded-lg flex flex-row group lg:gap-4 gap-[10px] lg:hover:shadow-card lg:p-[8px]">
      <div style={{ width: imageWidth }} className="relative flex-shrink-0">
        <div className="flex justify-center w-full aspect-class overflow-hidden rounded-md">
          <img
            src={getResizedImgUrl(thumbnail, "560")}
            alt=""
            className="rounded-md scale-100 duration-200 lg:group-hover:scale-105"
          />
        </div>
        {isShowClassNameBox && (
          <>
            <div className="classnamebox" />
            <div className="flex items-center space-x-1 absolute bottom-0 px-2 py-1 w-full truncate">
              <i className="ii-user text-sm text-secondary-50 z-20"></i>
              <div className="text-xs font-medium !text-secondary-50 truncate z-20 mt-[2px]">
                {lecturers.join(",")}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col justify-start flex-1 min-w-0">
        <div
          className={cls(
            "text-[14px] leading-[20px] tracking-[-0.1px] !text-medi-text-primary font-bold line-clamp-1 pt-[3px]",
            "lg:text-[18px lg:leading-[28px] lg:tracking-[-0.12px] lg:line-clamp-2 lg:pt-[8px]",
          )}
        >
          {highlightedText ? highlightedText(title) : title}
        </div>
        {/* MARK: 채널명 */}
        {!!channel && (
          <div
            className={cls(
              "truncate w-full line-clamp-1 text-[14px] font-semibold text-medi-text-tertiary leading-[20px] tracking-[-0.1px]",
              channel?.channelId ? "hover:underline cursor-pointer" : "",
            )}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              navigate(`/${CHANNEL_ROUTE}/${channel?.channelId}`);
            }}
          >
            {channel?.title}
          </div>
        )}
        {topic?.length || topicCategory?.length ? (
          <div className="overflow-hidden h-[22px] mt-[8px]">
            {topic?.map((item, idx) => (
              <div
                key={`topic-${idx}`}
                className={cls(
                  "inline-block bg-secondary-100 mr-2 px-[6px] py-[2px] rounded-[3px] !text-medi-text-secondary text-[12px] leading-[18px] tracking-[-0.08px] font-medium whitespace-nowrap",
                  isMobile && idx >= 2 ? "hidden" : "block",
                )}
              >
                {isMobile && idx === 2 && topic.length > 2 ? "..." : item}
              </div>
            ))}
            {topicCategory?.map((item, idx) => (
              <div
                key={`cat-${idx}`}
                className="inline-block bg-secondary-100 mr-2 px-[6px] py-[2px] rounded-[3px] !text-medi-text-secondary text-[12px] leading-[18px] tracking-[-0.08px] font-medium whitespace-nowrap"
              >
                {item}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default HorizontalCourseCard;
